import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/services/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("bf_user");
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      return parsed || null;
    } catch (e) {
      console.error("Error parsing bf_user from localStorage:", e);
      localStorage.removeItem("bf_user");
      return null;
    }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("bf_jwt");
    if (!token) {
      setReady(true);
      return;
    }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("bf_user", JSON.stringify(r.data));
      })
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  const login = (token, u) => {
    if (!token || !u) {
      console.error("Invalid login data:", { token, u });
      return;
    }
    try {
      localStorage.setItem("bf_jwt", token);
      localStorage.setItem("bf_user", JSON.stringify(u));
      setUser(u);
    } catch (e) {
      console.error("Error storing auth data:", e);
    }
  };

  const logout = () => {
    localStorage.removeItem("bf_jwt");
    localStorage.removeItem("bf_user");
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, ready }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
